import React from 'react';
import { activationSteps, contactData } from './data';

const JakAktywowac = () => {
  return (
    <div className="pethelp-page">
      <section className="pethelp-hero">
        <div className="pethelp-eyebrow">Onboarding klienta</div>
        <h1 className="pethelp-title">Aktywacja pakietu krok po kroku.</h1>
        <p className="pethelp-lead">
          Po otrzymaniu linku aktywacyjnego od Pethelp skonfiguruj konto, dodaj
          dane pupila i przypisz bon w panelu klienta. Cały proces został
          rozpisany poniżej.
        </p>
      </section>

      <section className="pethelp-step-grid">
        {activationSteps.map((step, index) => (
          <div className="pethelp-step mb-3" key={step}>
            <span className="pethelp-step-index">{index + 1}</span>
            <div>{step}</div>
          </div>
        ))}
      </section>

      <section className="pethelp-gallery-card full mt-4">
        <img
          src="/tvp/pethelp-image3.png"
          alt="Wejście do sekcji moje zwierzaki"
        />
        <div className="pethelp-gallery-caption">
          1. Najpierw wejdź do panelu klienta i przejdź do sekcji „Moje
          zwierzaki”.
        </div>
      </section>

      <section className="pethelp-activation-row mt-4">
        <div className="pethelp-gallery-card">
          <img
            src="/tvp/pethelp-image6.png"
            alt="Formularz dodawania zwierzaka"
          />
          <div className="pethelp-gallery-caption">
            2. Dodaj pupila i uzupełnij wymagane dane.
          </div>
        </div>
        <div className="pethelp-gallery-card">
          <img
            src="/tvp/pethelp-image7.png"
            alt="Widok dodanego zwierzaka w panelu"
          />
          <div className="pethelp-gallery-caption">
            3. Po zapisaniu zwierzak pojawi się na Twojej liście.
          </div>
        </div>
      </section>

      <section className="pethelp-gallery-card full">
        <img
          src="/tvp/pethelp-image8.png"
          alt="Aktywacja bonu w panelu Pethelp"
        />
        <div className="pethelp-gallery-caption">
          4. Na końcu aktywuj bon w zakładce „Moje bony”.
        </div>
      </section>

      <div className="pethelp-note">
        Do aktywacji bonu potrzebny jest numer telefonu. Jeśli chcesz aktywować
        więcej niż jeden pakiet, przygotuj kolejne adresy e-mail.
      </div>

      <div className="pethelp-actions">
        <a
          href={contactData.website}
          target="_blank"
          rel="noopener noreferrer"
          className="pethelp-cta">
          Otwórz panel Pethelp
        </a>
      </div>
    </div>
  );
};

export default JakAktywowac;
